import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import moment from 'moment';

import { collection, getFirestore, getDocs, query, orderBy, where, doc} from "firebase/firestore"
import app from "../../api/firebaseConf"

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import Test from "./Test"


export default function History(){
    const [starDate, setStartDate] = React.useState(new Date());
    const [endDate, setEndDate] = React.useState(new Date());
    const [sensor, setSensor] = useState('');
    const [slot,setSlot] = useState([])
    const [datoS,setDatoS] = useState([])
    const [fechaS, setFechaS] = useState([])
    const [tipo, setTipo] = useState('line')
    
    const db = getFirestore(app)

    

    const handleSubmit = () =>{
        console.log('inicio:',moment(starDate).format() )
        console.log('final:',moment(endDate).format())
        console.log('sensor:',sensor)

        const datos = []
        const fechas = []
        const obtener = async()=>{       
            const documento  = collection(doc(collection(db, 'datasensores'),'user'),sensor)
            const queri = query(documento, where("fecha",  ">=", starDate),where("fecha",  "<=", endDate),orderBy("fecha"))
            const querysnap = await getDocs(queri)
            
            querysnap.forEach((doc) => {
                if (isNaN(doc.data().dato)){
                    setTipo('bar')
                }else{
                    setTipo('line')
                }
                if (doc.data().dato === 'open'){
                    datos.push(2)
                }else if (doc.data().dato === 'close'){
                    datos.push(1)
                }else{
                    datos.push(doc.data().dato)
                }
                
                fechas.push(moment(doc.data().fecha.toDate().valueOf()).format('LTS'))
                // console.log({dato: doc.data().dato, fecha: moment(doc.data().fecha.toDate().valueOf()).format()})
               
              })
             
                
              
            setDatoS(datos)
            setFechaS(fechas)
            console.log(datoS)
            console.log(fechas)
        }

        obtener()
        console.log(tipo)
        
    }
   
    const array = []
    useEffect(()=>{
        const getGrafics = async() =>{
        const datos = await getDocs(collection(db,'sensores'));    
        datos.forEach((doc) => {
            array.push({label: doc.data().nombre, value: doc.data().variable, id: doc.id})
            
        })
        setSlot(array)
        }
        getGrafics()

    },[])

    const handleChange = (event) => {
        setSensor(event.target.value);
    };

    const firedata = {
        labels: fechaS,
        datasets: [{
          label: sensor !== '' ? sensor.charAt(0).toUpperCase() + sensor.slice(1) : 'Historico',
          data: datoS,
          backgroundColor: ['#EC464640','#3BA5FD40'],
          pointBackgroundColor: '#EC4646',
          pointBorderColor: '#EC4646',
          borderColor: ['#EC4646','#3BA5FD'],
          borderWidth: 2,
          fill: true,
          tension: 0.3
  
      }]
      }
    const options = {
        plugins: {
        legend: {
            labels: {
                
                font: {
                    size: 16,
                    weight: "bold"
                }
            }
        },
        scales: { 
        y: {
            min: 0,
            max: 80,
        }
        }
    }
    
    }
    
    return (
    <div className='pt-14 sm:pt-0'>
        <h1 className="text-3xl font-press-start font-bold uppercase mb-4">Historico</h1>

        <div className='bg-white rounded-lg shadow-sm p-4'>
            <div className='grid grid-cols-1 md:grid-cols-1 justify-items-center  gap-2 pb-4'>
                <div className='grid items-center justify-items-center grid-cols-1 md:grid-cols-2  gap-2'>
                    <div className='grid justify-items-center w-full'>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Fecha inicio</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateTimePicker
                        renderInput={(props) => <TextField {...props} />}
                        label="Inicio"
                        value={starDate}
                        onChange={(newValue) => {
                        setStartDate(newValue);
                        }}
                    />
                    </LocalizationProvider>
                    </div>
                    <div className='grid justify-items-center w-full'>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Fecha fin</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateTimePicker
                        renderInput={(props) => <TextField {...props} />}
                        label="Fin"
                        value={endDate}
                        onChange={(newValue) => {
                        setEndDate(newValue);
                        }}
                    />
                    </LocalizationProvider>
                    </div>
                </div>
                    <div className='grid justify-items-center w-full'>
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Sensor</label>
                        <Box sx={{ minWidth: 220}}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Sensor</InputLabel>
                            <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={sensor}
                            label="Sensor"
                            onChange={handleChange}
                            >
                            {slot.map((value)=>{
                                return <MenuItem value={value.value} key={value.id}>{value.label}</MenuItem>
                            })}
                            
                            </Select>
                        </FormControl>
                        </Box>
                    </div>
            </div>
            
            
            <div className='grid justify-items-center px-6 py-3 md:px-8'>
            <button 
                type="button" 
                className="inline-flex justify-center rounded-md border 
                border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium
                text-white hover:bg-blue-700 w-3/4 sm:w-2/4  sm:text-sm"
                onClick={handleSubmit}
                >
                Buscar
            </button>
            </div>
        
        </div>
        <div className='bg-white rounded-lg shadow-sm mt-4 p-4'>
        <div>
            <Test tipo_s={tipo} firedata={firedata} options = {options}/>
        </div>
        </div>
        
    </div>)
}